export default {"src":"/_next/static/media/nudafa-logo.64d16a05.svg","height":567,"width":2126,"blurWidth":0,"blurHeight":0};